module.exports = __webpack_public_path__ + "static/media/fju.6c15a543.png";